import { useQuestionizerStore } from "../types/state.ts";
import InputAntragsteller from "./input-antragsteller.tsx";
import InputBaujahr from "./input-baujahr.tsx";
import InputEvu from "./input-evu.tsx";
import InputGebaeudeTyp from "./input-gebaeude-typ.tsx";
import InputGewerk from "./input-gewerk.tsx";
import InputGrundversorger from "./input-grundversorger.tsx";
import InputPlz from "./input-plz.tsx";

import InputGemeinnuetzig from "./input-gemeinnuetzig.tsx";
import InputWohngebaeude from "./input-wohngebaude.tsx";
import InputGewerbeGebaeude from "./input-gewerbegebaeude.tsx";
import InputAntragstellerSelect from "./input-antragsteller-select.tsx";
import InputGebaeudeTyp3 from "./input-gebaeude-typ-3.tsx";
import InputAltbauNeubau from "./input-altbau-neubau.tsx";
import InputForm from "./input-form.tsx";
import InputResult from "./questionizer-result.tsx";
import InputGroupToggle from "./input-group-toggle.tsx";
import { Section } from "./section.tsx";
import { QuestionizerConfigSection } from "../types/questionizer-config.ts";
import { Button } from "./button.tsx";
import { Group } from "./section-group.tsx";
import { PlainSection } from "./section-plain.tsx";
import { useEffect, useRef } from "react";

export default function QuestionizerForm(){
    const step = useQuestionizerStore((state) => state.step);  
    const config = useQuestionizerStore((state) => state.config);
    const baseurl = config?.baseurl! || "";
    
    const L = useQuestionizerStore((state) => state.L);
    const active_groups = useQuestionizerStore((state) => state.active_groups);
    const active_group = useQuestionizerStore((state) => state.active_group);
    const toggleGroup = useQuestionizerStore((state) => state.toggleGroup);
    const deactivateGroup = useQuestionizerStore((state) => state.deactivateGroup);
    const last_toggle_ref = useQuestionizerStore((state) => state.last_toggle_ref);
    const setLastToggleRef = useQuestionizerStore((state) => state.setLastToggleRef);

    const modal_ref = useRef<HTMLDivElement>(null);
    const close_button_ref =  useRef<HTMLButtonElement>(null);

    useEffect(()=>{
      if(active_group && modal_ref.current){
        modal_ref.current.focus();
      }else if(!active_group && last_toggle_ref && last_toggle_ref!.current){
        last_toggle_ref.current.focus();
        setLastToggleRef(null);
      }
    },[active_group]);
      

    if (!config){
      return <div>Ein Fehler ist aufgetreten: Keine Konfiguration gefunden.</div>
    }
    

    let currentStep = config!.layout[step];
    if(!currentStep){
      currentStep = config!.layout[0];
    }

    const plain_sections = currentStep.sections.filter(section => !("groups" in section)).map((section,section_index) => {

      let layout = 'section__inputs--grid'
      if (section.type === "column") {
        layout = "w-full flex flex-col";
      }else if (section.type === "row") {
        layout = "w-full flex flex-row";
      }

      const is_group_section = "groups" in section;
      const section_active = is_group_section ? section.groups?.includes(active_group ?? 99) : true;

      const section_id = (section.id == undefined ? section_index : section.id);
      const group_id = "groups" in section ? section.groups![0] : 0;

      return (
      <PlainSection key={section_id} id={section_id} index={section_index} active={section.inputs.length > 0 && section_active}>
        {(section.title || section.info_top) && <div role="heading" aria-level="2" className="section__header">
          {section.title && <h2 id={'title-'+section_id} className="section__title">{L(section.title) || section.title}</h2>}
          {section.info_top && <p id={'description-'+section_id} className="section__info-top">{L(section.info_top) || section.info_top}</p>}
        </div>}
        <div className={"section__inputs " + layout}>
          {section.type === "grid" && section.inputs.length == 2 ? <div className={"hidden md:block sm:col-span-2"}></div> : <></>}
          <SectionInputs section={section}/>
          </div>
        {section.info_bottom && <p role="note" className="section__info-bottom">{L(section.info_bottom) || section.info_bottom}</p>}
      </PlainSection>);
    });
    
    const modal_sections = currentStep.sections.filter(section => "groups" in section).map((section,section_index) => {

      let layout = 'section__inputs--grid'
      if (section.type === "column") {
        layout = "w-full flex flex-col";
      }else if (section.type === "row") {
        layout = "w-full flex flex-row";
      }

      const is_group_section = "groups" in section;
      const section_active = is_group_section ? section.groups?.includes(active_group ?? 99) : true;

      const section_id = (section.id == undefined ? section_index : section.id);
      const group_id = "groups" in section ? section.groups![0] : 0;

      return (
      <Group key={section_id} group_id={group_id} id={section_id} index={section_index} active={section_active}>
        {(section.title || section.info_top) && <div role="heading" aria-level="2" className="section__header">
          {section.title && <h2 id={'title-'+section_id} className="section__title">{L(section.title) || section.title}</h2>}
          {section.info_top && <p id={'description-'+section_id} className="section__info-top">{L(section.info_top) || section.info_top}</p>}
        </div>}
        <div className={"section__inputs " + layout}>
          {section.type === "grid" && section.inputs.length == 2 ? <div className={"hidden md:block sm:col-span-2"}></div> : <></>}
          <SectionInputs section={section}/>
          </div>
        {section.info_bottom && <p role="note" className="section__info-bottom">{L(section.info_bottom) || section.info_bottom}</p>}
      </Group>);
    });

    return (<div aria-atomic="true" aria-describedby="h1" 
      onKeyUp={(event)=>{
        if (event.code != "Escape") { return } 
        deactivateGroup();
      }}>

      {active_group && <>
        <div aria-hidden onClick={()=>{
          deactivateGroup();
        }} className="modal-background">
        </div>
        <div className="modal-body"
         aria-labelledby={"input-"+active_group}
         aria-modal="true" 
         role="dialog"
         tabIndex={-1} 
         ref={modal_ref}>
          {!config.alternative_modal_close_button ? <button 
            ref={close_button_ref}
            type="button"
            aria-label="schließen"
            aria-hidden
            className="modal__close-button"
            onClick={()=>{
              deactivateGroup();
            }}
          ></button> :
          <button 
            ref={close_button_ref}
            type="button"
            aria-label="schließen"
            aria-hidden
            className="modal__close-button--alt"
            onClick={()=>{
              deactivateGroup();
            }}
          >{L('modal-btn--auswahl-uebernehmen') || 'Auswahl übernehmen'}</button>}
          {modal_sections}
          <div tabIndex={0} onFocus={()=>{
            if(close_button_ref && close_button_ref.current){
              close_button_ref.current.focus();
            }
          }}></div>
        </div>
       </>}
      <div inert={active_group ? true : false}>
        	<h1 id="h1" className="form__title">{L(currentStep.title) || currentStep.title}</h1>
          <div id="form"  className={`form form-${step ?? 0}`}>      
            {plain_sections}
          </div>
      </div>
		
		  </div>);   
  }     


function SectionInputs(props: {section: QuestionizerConfigSection}){
  //const active_group = useQuestionizerStore((state) => state.active_group);
  const config = useQuestionizerStore((state) => state.config);
  const baseurl = config?.baseurl! || "";
  const L = useQuestionizerStore((state) => state.L);
  const lang = useQuestionizerStore((state) => state.lang);
  const t = (s?: string) => s ? (L(s) || s) : s;
  const li = (path: string): string => {
    if (!lang || lang === 'de' || !path) return path;
    const lastSlash = path.lastIndexOf('/');
    if (lastSlash === -1) return path;
    return path.slice(0, lastSlash + 1) + lang + '/' + path.slice(lastSlash + 1);
  };

  return props.section.inputs.map( (input, index, array) => {
            let is_last = index == array.length - 1;
          const onBlur = ()=>{};

          switch (input.type){
            case 'plz':
              return <InputPlz label={t(input.label)}id={input.id} key={input.id} onBlur={onBlur}></InputPlz>
            case 'grouptoggle':
             return <InputGroupToggle label={t(input.label)} info_title={t(input.info_title)} info_text={t(input.info_text)} icon={li(baseurl + input.icon)} icon_active={li(baseurl + input.icon_active)} id={input.id} deactivate_ids={input.deactivate_ids} key={input.id} onBlur={()=>{
                //onBlur();
             }}/>
            case 'gewerk':
              return <InputGewerk label={t(input.label)}info_title={t(input.info_title)} info_text={t(input.info_text)} icon={li(baseurl + input.icon)} icon_active={li(baseurl + input.icon_active)} id={input.id} deactivate_ids={input.deactivate_ids} key={input.id} onBlur={onBlur}></InputGewerk>
            case 'altbau_neubau':
                return <InputAltbauNeubau
                label={input.label}
                label_altbau={t(input.label_altbau)}
                label_neubau={t(input.label_neubau)}
                icon_altbau={li(baseurl + input.icon_altbau)}
                icon_altbau_active={li(baseurl + input.icon_altbau_active)}
                icon_neubau={li(baseurl + input.icon_neubau)}
                icon_neubau_active={li(baseurl + input.icon_neubau_active)}
                id={input.id}
                key={input.id} onBlur={onBlur}></InputAltbauNeubau>
            case 'gebaeude_typ':
              return <InputGebaeudeTyp
                label={input.label}
                label_einfamilienhaus={t(input.label_einfamilienhaus)}
                label_mehrfamilienhaus={t(input.label_mehrfamilienhaus)}
                icon_einfamilienhaus={li(baseurl + input.icon_einfamilienhaus)}
                icon_einfamilienhaus_active={li(baseurl + input.icon_einfamilienhaus_active)}
                icon_mehrfamilienhaus={li(baseurl + input.icon_mehrfamilienhaus)}
                icon_mehrfamilienhaus_active={li(baseurl + input.icon_mehrfamilienhaus_active)}
                id={input.id} key={input.id} onBlur={onBlur}></InputGebaeudeTyp>
            case 'gebaeude_typ_3':
              return <InputGebaeudeTyp3
                label={input.label}
                label_einfamilienhaus={t(input.label_einfamilienhaus)}
                label_mehrfamilienhaus={t(input.label_mehrfamilienhaus)}
                label_nichtwohngebaeude={t(input.label_nichtwohngebaeude)}
                icon_einfamilienhaus={li(baseurl + input.icon_einfamilienhaus)}
                icon_einfamilienhaus_active={li(baseurl + input.icon_einfamilienhaus_active)}
                icon_mehrfamilienhaus={li(baseurl + input.icon_mehrfamilienhaus)}
                icon_mehrfamilienhaus_active={li(baseurl + input.icon_mehrfamilienhaus_active)}
                icon_nichtwohngebaeude={li(baseurl + input.icon_nichtwohngebaeude)}
                icon_nichtwohngebaeude_active={li(baseurl + input.icon_nichtwohngebaeude_active)}
                id={input.id}
                key={input.id} onBlur={onBlur}></InputGebaeudeTyp3>
            case 'baujahr':
              return <InputBaujahr label={t(input.label)}id={input.id} key={input.id} onBlur={onBlur}></InputBaujahr>
            case 'grundversorger':
              return <InputGrundversorger label={t(input.label)}id={input.id} key={input.id} onBlur={onBlur}></InputGrundversorger>
            case 'antragsteller':
              return <InputAntragsteller label={t(input.label)}icon={li(baseurl + input.icon)} icon_active={li(baseurl + input.icon_active)} antragsteller_type={input.code} id={input.id} key={input.id} onBlur={onBlur}></InputAntragsteller>
            case 'antragsteller-select':
                return <InputAntragstellerSelect label={t(input.label)}id={input.id} key={input.id} onBlur={onBlur}></InputAntragstellerSelect>
            case 'evu':
              return <InputEvu label={t(input.label)}id={input.id} key={input.id} onBlur={onBlur}></InputEvu>
            case 'gemeinnuetzig':
              return <InputGemeinnuetzig label={t(input.label)}icon={li(baseurl + input.icon)} icon_active={li(baseurl + input.icon_active)} id={input.id} key={input.id}  onBlur={onBlur}/>
            case 'wohngebaeude':
              return <InputWohngebaeude label={t(input.label)}icon={li(baseurl + input.icon)} icon_active={li(baseurl + input.icon_active)} id={input.id} key={input.id} onBlur={onBlur}/>
            case 'form':
              return <InputForm id={input.id}  firstname={input.firstname} lastname={input.lastname} email={input.email} tel={input.tel} key={input.id} dataprotection_link={input.dataprotection_link}  dataprotection_link_text={input.dataprotection_link_text} dataprotection_a={input.dataprotection_a} dataprotection_b={input.dataprotection_b} onBlur={onBlur}/> 
            case 'result':
              return <InputResult id={input.id} key={input.id} onBlur={onBlur}/> 
            case 'gewerbegebaeude':
              return <InputGewerbeGebaeude label={t(input.label)}icon={li(baseurl + input.icon)} icon_active={li(baseurl + input.icon_active)} id={input.id} key={input.id} onBlur={onBlur}/>
          }
        });
}